import { PaymentProfileStatus, PaymentProfileType } from '../../models';

export const STATUS_ORDER: Record<PaymentProfileStatus, number> = {
  active: 0,
  normal: 1,
  expired: 2,
  unavailable: 3,
} as const;

export const TYPE_ODER: Record<PaymentProfileType, number> = {
  credit_card: 0,
  bank_account: 1,
} as const;

export const SORT_WEIGHT = 10;
